import React from 'react';
import PropTypes from 'prop-types';
import SalesAndPromotionsPanelResult from './SalesAndPromotionsPanelResult';
import './SalesAndPromotionsPanelResults.scss';

const SalesAndPromotionsPanelResults = ({ page, isLoading, error, savingIds, updateSale, changePage }) => (
  <div className='sales-and-promotions-panel-results'>
    <div className='sales-table-scroll'>
      <table aria-label='Public sales' aria-busy={isLoading}>
        <thead>
          <tr>
            {['Sale', 'Status', 'Sale dates (ET)', 'Added', 'Creator placement', ''].map(label => (
              <th key={label} scope='col'>
                {label}
              </th>
            ))}
          </tr>
        </thead>
        {page?.sales.map(sale => (
          <SalesAndPromotionsPanelResult key={sale.id} sale={sale} saving={!!savingIds[sale.id] || isLoading || !!error} updateSale={updateSale} />
        ))}
        {!page?.sales.length && (
          <tbody>
            <tr>
              <td colSpan={6} className='empty-sales'>
                {isLoading ? 'Loading sales…' : error ? 'No sales loaded.' : 'No sales match. Try another status or clear your search.'}
              </td>
            </tr>
          </tbody>
        )}
      </table>
    </div>
    {page && (
      <footer className='sales-pagination'>
        <span role='status'>
          {isLoading ? 'Updating sales…' : `${page.pageInfo.totalCount} ${page.pageInfo.totalCount === 1 ? 'sale' : 'sales'}`}
        </span>
        <div>
          <button
            type='button'
            disabled={isLoading || page.pageInfo.offset === 0}
            onClick={() => changePage(Math.max(0, page.pageInfo.offset - page.pageInfo.limit))}
          >
            Previous
          </button>
          <span>Page {Math.floor(page.pageInfo.offset / page.pageInfo.limit) + 1}</span>
          <button type='button' disabled={isLoading || !page.pageInfo.hasMore} onClick={() => changePage(page.pageInfo.offset + page.pageInfo.limit)}>
            Next
          </button>
        </div>
      </footer>
    )}
  </div>
);
SalesAndPromotionsPanelResults.propTypes = {
  page: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.string.isRequired,
  savingIds: PropTypes.object.isRequired,
  updateSale: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired
};
export default SalesAndPromotionsPanelResults;
